import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_ctx.disabled)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : (_ctx.isV1Legacy)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.to
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 8, _hoisted_2))
      : (_openBlock(), _createBlock(_component_RouterLink, {
          key: 2,
          to: _ctx.to
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["to"]))
}